var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var _a;
import React, { useEffect, useRef, useState } from 'react';
import { cloneDeep } from 'lodash';
import isEmpty from 'lodash/isEmpty';
import Button from '../button';
import Icon from '../icon';
import SchedulePicker, { ScheduleActions } from '../schedule-picker';
import { Styled } from './style';
export var DayOfWeekEnum;
(function (DayOfWeekEnum) {
    DayOfWeekEnum["SUNDAY"] = "sun";
    DayOfWeekEnum["MONDAY"] = "mon";
    DayOfWeekEnum["TUESDAY"] = "tue";
    DayOfWeekEnum["WEDNESDAY"] = "wed";
    DayOfWeekEnum["THURSDAY"] = "thu";
    DayOfWeekEnum["FRIDAY"] = "fri";
    DayOfWeekEnum["SATURDAY"] = "sat";
})(DayOfWeekEnum || (DayOfWeekEnum = {}));
var defaultDayOfWeek = (_a = {},
    _a[DayOfWeekEnum.MONDAY] = true,
    _a[DayOfWeekEnum.TUESDAY] = true,
    _a[DayOfWeekEnum.WEDNESDAY] = true,
    _a[DayOfWeekEnum.THURSDAY] = true,
    _a[DayOfWeekEnum.FRIDAY] = true,
    _a[DayOfWeekEnum.SATURDAY] = true,
    _a[DayOfWeekEnum.SUNDAY] = true,
    _a);
var defaultRule = [
    {
        _key: 0,
        time: [],
        day_of_week: {
            fri: true,
            mon: true,
            sat: true,
            sun: true,
            thu: true,
            tue: true,
            wed: true,
        },
        date: [],
        exclusive: false,
        full_screen: false,
        specific_date: false,
    },
];
var usePrevious = function (value) {
    var ref = useRef();
    useEffect(function () {
        ref.current = value;
    });
    return ref.current;
};
export var MultilineSchedulePicker = function (props) {
    var _a = useState(props.rules), rules = _a[0], setRules = _a[1];
    var _b = useState(1), ruleKey = _b[0], setRuleKey = _b[1];
    var prevRules = usePrevious(rules);
    useEffect(function () {
        if (isEmpty(props.rules)) {
            setRules(defaultRule);
        }
    }, [props.rules]);
    useEffect(function () {
        if (!isEmpty(prevRules) && prevRules !== rules) {
            setRules(rules);
        }
    }, [rules]);
    var addItem = function () {
        setRuleKey(ruleKey + 1);
        var newDefaultRules = [
            {
                _key: ruleKey,
                time: [],
                day_of_week: {
                    fri: true,
                    mon: true,
                    sat: true,
                    sun: true,
                    thu: true,
                    tue: true,
                    wed: true,
                },
                date: [],
                exclusive: false,
                full_screen: false,
                specific_date: false,
            },
        ];
        setRules(__spreadArrays(rules, newDefaultRules));
    };
    var removeItem = function (index) {
        var callback = props.callback;
        var updatedRules = rules.filter(function (item, idx) { return idx !== index; });
        setRules(updatedRules);
        callback && callback(updatedRules);
    };
    var handleRulesChange = function (index, action, data) {
        var callback = props.callback;
        var updateRules = cloneDeep(rules);
        switch (action) {
            case ScheduleActions.ExclusiveToggled:
                updateRules[index].exclusive = data.checked;
                setRules(updateRules);
                break;
            case ScheduleActions.FullScreenToggled:
                updateRules[index].full_screen = data.checked;
                setRules(updateRules);
                break;
            case ScheduleActions.DayOfWeekChanged:
                updateRules[index].day_of_week = data.day_of_week;
                setRules(updateRules);
                break;
            case ScheduleActions.DateChanged:
                updateRules[index].date = data.date;
                updateRules[index].specific_date = data.specific_date;
                setRules(updateRules);
                break;
            case ScheduleActions.TimeChanged:
                updateRules[index].time = data.time;
                setRules(updateRules);
                break;
            case ScheduleActions.SpecificDateToggled:
                updateRules[index].specific_date = data.specific_date;
                setRules(updateRules);
                break;
            default:
                break;
        }
        callback && callback(updateRules);
    };
    return (React.createElement("div", null,
        React.createElement(Styled, { disabled: props.disabled },
            React.createElement("div", { className: "item-group" }, rules.length > 0 && rules.map(function (rule, index) {
                var _a, _b, _c, _d;
                return (React.createElement("div", { key: "rule-" + index, className: "item-row" },
                    React.createElement(SchedulePicker, { key: "picker-rule-" + index, isExclusiveEnabled: (_a = rule.exclusive) !== null && _a !== void 0 ? _a : false, isFullScreenEnabled: (_b = rule.full_screen) !== null && _b !== void 0 ? _b : false, isSpecificDateEnabled: (_c = rule.specific_date) !== null && _c !== void 0 ? _c : false, showFullscreenOption: props.showFullscreenOption, time: rule.time, dayOfWeek: rule.day_of_week ? rule.day_of_week : defaultDayOfWeek, locale: props.locale, date: rule.date, overlapList: !isEmpty(props.overlapList) ? (_d = props.overlapList) === null || _d === void 0 ? void 0 : _d.schedules[index] : {}, callback: function (action, data) { return handleRulesChange(index, action, data); } }),
                    rules.length > 1 &&
                        React.createElement(Button, { className: "btn-remove-item", onClick: function () {
                                removeItem(index);
                            }, tabIndex: "-1", transparent: true },
                            React.createElement(Icon, { name: "remove-fill" }))));
            })),
            React.createElement(Button, { onClick: addItem, transparent: true, className: "btn-add-item" },
                React.createElement(Icon, { name: "plus-fill" }),
                React.createElement("span", null, "Add")))));
};
export default MultilineSchedulePicker;
//# sourceMappingURL=index.js.map